<div class="popupsec" id="popupsec">
  <a (click)="closeDialog()" class="md-dialog-close waves-effect closebtncls">
    <i class="material-icons btn-floating btn-small waves-effect waves-light cross-icon-bg"></i>
  </a>
  <div id="contentSec">
    <h2 md-dialog-title>Remove Office</h2>
    <md-dialog-content>
      <div>
        <p class="title">{{this._appMessage.getItem['UMsg00062']}}</p>
        <p class="sub-title">Remove {{officeData.element.name}} ?</p>
        <p class="title">Replace With</p>
      </div>
      <form [formGroup]="form">
        <div class="row">
          <div class="col s12 m5 l5 noPaddingLeft">
            <md-form-field class="example-full-width">
              <input mdInput placeholder="Add New" maxlength="50" formControlName="newOffice">
            </md-form-field>
          </div>
          <div class="col s12 m2 l2">OR</div>
          <div class="col s12 m5 l5 noPaddingRight">
            <md-select placeholder="Select" formControlName="selectOffice">
              <md-option>Select</md-option>
              <md-option *ngFor="let option of showOfficeList" [value]="option">
                {{ option.name}}
              </md-option>
            </md-select>
          </div>
        </div>
      </form>

      <div class="button-row">
        <button [disabled]="!(form.controls.newOffice.value || form.controls.selectOffice.value)" md-raised-button class="glbAdminBtnCls1"
          (click)="onReplace()">
          REPLACE</button>
        <button md-raised-button class="glbAdminBtnCls1" (click)="onDelete()">
          REMOVE ANYWAY</button>
      </div>
    </md-dialog-content>
  </div>
</div>



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-office/adm-remove-office/adm-remove-office.component.html